import { useState } from 'react';
import type { ReactNode } from 'react';
import { Header } from './Header';
import { SlideMenu } from './SlideMenu';
import { PageContainer } from './PageContainer';
import { OfflineNotice } from '../common/OfflineNotice';

interface AppShellProps {
  children: ReactNode;
  headerRightElement?: ReactNode;
}

export function AppShell({ children, headerRightElement }: AppShellProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <PageContainer>
      <Header
        onMenuClick={() => setIsMenuOpen(true)}
        rightElement={headerRightElement}
      />
      <SlideMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      <main className="px-4 py-6">
        <OfflineNotice />
        {children}
      </main>
    </PageContainer>
  );
}
